(() => {

  const initialize = () => {

    const root = document.querySelector('.i6-page-root');

    if (!root || root.dataset.i6Initialized === 'true') return;

    root.dataset.i6Initialized = 'true';



    const glow = document.createElement('div');

    glow.id = 'mouseGlow';

    root.appendChild(glow);

    let mouseX = 0;

    let mouseY = 0;

    let glowX = 0;

    let glowY = 0;

    root.addEventListener('mousemove', (event) => {

      mouseX = event.clientX;

      mouseY = event.clientY;

    });

    const animateGlow = () => {

      glowX += (mouseX - glowX) * 0.1;

      glowY += (mouseY - glowY) * 0.1;

      glow.style.left = `${glowX}px`;

      glow.style.top = `${glowY}px`;

      window.requestAnimationFrame(animateGlow);

    };

    animateGlow();



    root.querySelectorAll('.parallax-container').forEach((container) => {

      const image = container.querySelector('.parallax-image');

      if (!image) return;

      container.addEventListener('mousemove', (event) => {

        const rect = container.getBoundingClientRect();

        const moveX = ((event.clientX - rect.left - rect.width / 2) / (rect.width / 2)) * 15;

        const moveY = ((event.clientY - rect.top - rect.height / 2) / (rect.height / 2)) * 15;

        image.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.05)`;

      });

      container.addEventListener('mouseleave', () => {

        image.style.transform = 'translate(0, 0) scale(1)';

      });

    });



    const revealObserver = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) entry.target.classList.add('visible');

      });

    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    root.querySelectorAll('.fade-in-up').forEach((element) => revealObserver.observe(element));



    root.querySelectorAll('.word-fade-in').forEach((element) => {

      const words = element.textContent.trim().split(/\s+/);

      element.replaceChildren(...words.flatMap((word, index) => {

        const span = document.createElement('span');

        span.textContent = `${word} `;

        span.style.animationDelay = `${index * 0.1}s`;

        return [span];

      }));

    });



    root.querySelectorAll('.split-image img, .feature-image img').forEach((image) => {

      image.parentElement?.classList.add('vignette');

    });

    root.querySelectorAll('.btn').forEach((button) => {

      button.addEventListener('mousemove', (event) => {

        const rect = button.getBoundingClientRect();

        button.style.setProperty('--x', `${event.clientX - rect.left}px`);

        button.style.setProperty('--y', `${event.clientY - rect.top}px`);

      });

    });



    const productObserver = new IntersectionObserver((entries, observer) => {

      entries.forEach((entry) => {

        if (!entry.isIntersecting) return;

        const index = Number(entry.target.dataset.i6Index || 0);

        window.setTimeout(() => entry.target.classList.add('in-view'), index * 100);

        observer.unobserve(entry.target);

      });

    }, { threshold: 0.1 });

    root.querySelectorAll('.product-card-enhanced').forEach((card, index) => {

      card.dataset.i6Index = index;

      card.style.animationDelay = `${index * 0.1}s`;

      productObserver.observe(card);

    });



    root.addEventListener('click', (event) => {

      const question = event.target.closest('.faq-question');

      const faq = question?.closest('[data-faq-section]');

      const item = question?.closest('.faq-item');

      if (!faq || !item) return;

      const willOpen = !item.classList.contains('active');

      faq.querySelectorAll('.faq-item').forEach((other) => {

        other.classList.remove('active');

        other.querySelector('.faq-question')?.setAttribute('aria-expanded', 'false');

      });

      if (willOpen) {

        item.classList.add('active');

        question.setAttribute('aria-expanded', 'true');

      }

    });



    const createParticles = (container) => {

      for (let index = 0; index < 4; index += 1) {

        const particle = document.createElement('div');

        particle.className = 'particle';

        particle.style.left = `${Math.random() * 100}%`;

        particle.style.top = `${Math.random() * 100}%`;

        particle.style.animationDelay = `${Math.random() * 8}s`;

        container.appendChild(particle);

      }

    };

    root.querySelectorAll('.hero, .final-cta').forEach(createParticles);



    root.querySelectorAll('[data-model-switcher]').forEach((switcher) => {

      const button = switcher.querySelector('[data-switcher-button]');

      const menu = switcher.querySelector('[data-switcher-menu]');

      const showAfter = Number(switcher.dataset.showAfter || 0);

      const close = () => {

        menu?.classList.remove('open');

        button?.setAttribute('aria-expanded', 'false');

      };

      button?.addEventListener('click', (event) => {

        event.stopPropagation();

        const open = !menu?.classList.contains('open');

        menu?.classList.toggle('open', open);

        button.setAttribute('aria-expanded', String(open));

      });

      document.addEventListener('click', (event) => {

        if (!switcher.contains(event.target)) close();

      });

      document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape') close();

      });

      const update = () => switcher.classList.toggle('visible', window.scrollY >= showAfter);

      window.addEventListener('scroll', update, { passive: true });

      update();

    });

  };



  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);

  else initialize();

})();

